import React from 'react';
import { Box, useTheme, keyframes } from '@mui/material';

interface GlobalLoaderProps {
  open: boolean;
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const GlobalLoader: React.FC<GlobalLoaderProps> = ({ open }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const primaryColor = (theme.palette as any).background?.primary || theme.palette.primary.main;

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: isDark
          ? 'rgba(18, 18, 18, 0.6)'
          : 'rgba(245, 247, 250, 0.7)',
        zIndex: 10,
        pointerEvents: 'all',
        backdropFilter: 'blur(2px)',
        animation: `${fadeIn} 0.15s ease-out`,
      }}
    >
      {/* Spinner */}
      <Box sx={{
        width: 40,
        height: 40,
        borderRadius: '50%',
        border: `3px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`,
        borderTopColor: primaryColor,
        animation: `${spin} 0.7s linear infinite`,
      }} />
    </Box>
  );
};

export default GlobalLoader;
